// uses ./sideloaded.less

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addSideloadedApp, closeSideloadedAppModal, loadAppDefinition } from './sideloadActionCreators';
import ConfirmationModal from '../common/ConfirmationModal';
import UploadSection from './UploadSection';
import ErrorsSection from './ErrorsSection';

import { resetFilters } from '../appsList/appsListFilters/appsListFiltersActionCreators';
import { withRouter } from '../../withRouter';

const Sideload = ({
    isVisible,
    history,
    appDefinitionFile,
    dispatchCloseSideloadedAppModal,
    isAppDefinitionLoaded,
    isAppDefinitionValid,
    validationErrorDownload,
    validationErrorMessage,
    validationErrorDetails,
    helpdeskArticleUrl,
    dispatchLoadAppDefinition,
    dispatchAddSideloadedApp,
}) => {
    if (!isVisible) {
        return null;
    }

    const handleFileLoadHandler = (event) => {
        dispatchLoadAppDefinition({
            appDefinitionFile: event.target.files[0],
        });
    };
    const handleAddSideloadedAppHandler = () => {
        dispatchAddSideloadedApp({
            sideloadedAppDefinition: appDefinitionFile,
        }).then(({ value: { appId } }) => {
            history.push(`/apps/${appId}`);
        });
    };

    return (
        <ConfirmationModal
            className="sideloaded-modal"
            closeHandler={dispatchCloseSideloadedAppModal}
            cancelLabel="Cancel"
            title="Create custom app"
            confirmHandler={handleAddSideloadedAppHandler}
            confirmLabel="Create"
            isDisabled={!isAppDefinitionLoaded || !isAppDefinitionValid}
        >
            <p className="sideloaded-modal-caption">
                Expand the functionality of your Egnyte domain. To learn more about building custom sideloading apps,
                please visit our{' '}
                <a href={helpdeskArticleUrl} target="_blank" rel="noreferrer" className="sideloaded-helpdesk-link">
                    Helpdesk article
                </a>
                .
            </p>

            <UploadSection
                isAppDefinitionLoaded={isAppDefinitionLoaded}
                appDefinitionFile={appDefinitionFile}
                onFileLoadHandler={handleFileLoadHandler}
            />
            <ErrorsSection
                isAppDefinitionValid={isAppDefinitionValid}
                validationErrorMessage={validationErrorMessage}
                validationErrorDownload={validationErrorDownload}
                validationErrorDetails={validationErrorDetails}
            />
        </ConfirmationModal>
    );
};

Sideload.propTypes = {
    appDefinitionFile: PropTypes.object,
    dispatchAddSideloadedApp: PropTypes.func.isRequired,
    dispatchCloseSideloadedAppModal: PropTypes.func.isRequired,
    isAppDefinitionLoaded: PropTypes.bool.isRequired,
    isAppDefinitionValid: PropTypes.bool.isRequired,
    validationErrorDownload: PropTypes.bool.isRequired,
    validationErrorMessage: PropTypes.string,
    validationErrorDetails: PropTypes.string,
    validationErrorsBlobUrl: PropTypes.string,
    helpdeskArticleUrl: PropTypes.string,
    isVisible: PropTypes.bool,
    history: PropTypes.object.isRequired,
    dispatchLoadAppDefinition: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchAddSideloadedApp: addSideloadedApp,
    dispatchCloseSideloadedAppModal: closeSideloadedAppModal,
    dispatchLoadAppDefinition: loadAppDefinition,
    dispatchResetFilters: resetFilters,
};

export default withRouter(
    connect(
        (state) => ({
            helpdeskArticleUrl: state.user.sideloadingHelpdeskUrl,
            ...state.sideload,
        }),
        mapDispatchToProps
    )(Sideload)
);
